import { AxiosResponse } from 'axios';
import ApiClient from './ApiClient';

export type TanomuImportError = {
  error: string;
  defaultMessage: string;
};

export const importTanomuDeliveryCsv = async (
  importDate: string,
  existData: number,
  uploadFile: File,
): Promise<AxiosResponse> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const params: Record<string, any> = {
    importDate,
    existData,
    loginStaffCode,
  };
  return ApiClient.postFile(
    `/v2/sales/ordering/tanomu/delivery/${companyCode}`,
    params,
    'uploadFile',
    uploadFile,
  );
};

export default { importTanomuDeliveryCsv };
